import { arrayToMap, last } from 'lib/array/arrayUtils'
import getLoyaltyEarnKey from './getLoyaltyEarnKey'

function isFlightItemFlight(flight: App.Checkout.FlightItemFlight | App.Checkout.FlightItemViewJourney): flight is App.Checkout.FlightItemFlight {
  return 'departingAirportCode' in flight
}

function isFlightItemViewJourney(flight: App.Checkout.FlightItemFlight | App.Checkout.FlightItemViewJourney): flight is App.Checkout.FlightItemViewJourney {
  return 'journeyFlight' in flight
}

/**
 * @Note why this malarkey?
 * For the current Garuda bonus points campaign, we want to support bonus points on flights from Melbourne to Bali (or vice versa) with
 * Garuda Airlines. However with a multi-city booking there could be a scenario where the traveller flies from Melbourne to Bali
 * then later from Malaysia to Sydney. In an ideal world we would only give out bonus points for the first leg, however because
 * all the legs end up as a single item, this causes complexity with the current loyalty earn calculation which works on a per-item basis.
 * Long term solution is to support grouping calculations together but for now we will just give extra points for the other legs.
 */
function getLoyaltyEarnKeyFromFlightItems(
  flights: Array<App.Checkout.FlightItemFlight>,
  loyaltyProductType: App.LoyaltyFlightProductType,
  airports: Array<App.Airport>,
): string | undefined

function getLoyaltyEarnKeyFromFlightItems(
  flights: Array<App.Checkout.FlightItemViewJourney>,
  loyaltyProductType: App.LoyaltyFlightProductType,
  airports?: undefined,
): string | undefined

function getLoyaltyEarnKeyFromFlightItems(
  flights: Array<App.Checkout.FlightItemFlight> | Array<App.Checkout.FlightItemViewJourney>,
  loyaltyProductType: App.LoyaltyFlightProductType,
  airports: Array<App.Airport> | undefined,
): string | undefined {
  let earnKey: string | undefined

  for (const flight of flights) {
    if (isFlightItemFlight(flight) && airports) {
      const airportsByCode = arrayToMap(airports, airport => airport.code)
      const departingAirport = airportsByCode.get(flight.departingAirportCode)
      const arrivalAirport = airportsByCode.get(flight.arrivalAirportCode)

      if (!departingAirport || !arrivalAirport) return

      earnKey = getLoyaltyEarnKey({
        loyaltyProductType,
        options: {
          originAirportCode: flight.departingAirportCode,
          destinationAirportCode: flight.arrivalAirportCode,
          carrier: flight.carrier,
          loyaltyEarnKey: flight.fareFamily?.loyaltyEarnKey,
        },
      })
    }

    if (isFlightItemViewJourney(flight)) {
      earnKey = getLoyaltyEarnKey({
        loyaltyProductType,
        options: {
          originAirportCode: flight.journeyFlight.flights[0].departingAirport,
          destinationAirportCode: last(flight.journeyFlight.flights).arrivalAirport,
          carrier: flight.journeyFlight.flights[0].carrier,
          loyaltyEarnKey: flight.fareFamily?.loyaltyEarnKey,
        },
      })
    }

    if (earnKey) {
      break
    }
  }

  return earnKey
}

export default getLoyaltyEarnKeyFromFlightItems
